export default __webpack_public_path__ + "static/media/Highlord's Spell Glaive.cdfc24c5.jpg";